import { render, staticRenderFns } from "./WebsiteLiveChatIndicator.vue?vue&type=template&id=053d8026&"
import script from "./WebsiteLiveChatIndicator.vue?vue&type=script&lang=js&"
export * from "./WebsiteLiveChatIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports